import {ActionList, ActionMenu, VisuallyHidden} from '@primer/react'

import {getProjectSortOption, PROJECT_SORT_OPTIONS, type ProjectSortValue} from './project-sort-options'

interface ProjectSortMenuProps {
  sort: ProjectSortValue
  onSortChange: (value: ProjectSortValue) => void
}

export function ProjectSortMenu({sort, onSortChange}: ProjectSortMenuProps) {
  const selected = getProjectSortOption(sort)

  return (
    <ActionMenu>
      <ActionMenu.Button variant="invisible">
        Sort
        <VisuallyHidden>: {selected.label}</VisuallyHidden>
      </ActionMenu.Button>
      <ActionMenu.Overlay align="end">
        <ActionList selectionVariant="single" aria-label="Sort projects by">
          {PROJECT_SORT_OPTIONS.map(option => (
            <ActionList.Item
              key={option.value}
              selected={option.value === sort}
              onSelect={() => onSortChange(option.value)}
            >
              {option.label}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
